// Locked, auto-detected categories for a collection; `autoCategory` covers older payloads.
export function autoCategoriesOf(c) {
  if (Array.isArray(c.autoCategories) && c.autoCategories.length) return c.autoCategories;
  return c.autoCategory ? [c.autoCategory] : [];
}

// The first collection with neither an auto-detected nor a picked category.
export function collectionMissingCategory(collections, picked) {
  return collections.find((c) => {
    const chosen = picked?.[c.id];
    return !autoCategoriesOf(c).length && (!Array.isArray(chosen) || chosen.length === 0);
  });
}

// Only collections whose categories differ from what the source declares are sent as overrides.
export function collectionCategoriesPayload(collections, picked) {
  const payload = {};
  for (const c of collections) {
    const auto = autoCategoriesOf(c);
    const merged = [...new Set([...auto, ...(Array.isArray(picked?.[c.id]) ? picked[c.id] : [])])];
    if (merged.length > auto.length) payload[c.id] = merged;
  }
  return payload;
}

// Every category picked for any collection.
export function categoriesFromCollections(picked) {
  const all = new Set();
  for (const value of Object.values(picked || {})) {
    if (Array.isArray(value)) value.forEach((c) => c && all.add(c));
    else if (typeof value === "string" && value) all.add(value);
  }
  return all;
}
